import React from "react";

const TrainListheader = () => {
  return (
    <div>
      <h1 className="uppercase text-center pt-16 text-2xl md:text-3xl font-bold">
        Train List
      </h1>
      <p className="text-center pb-16 md:text-3xl">
        use Search box to search trains (From: Colombo Fort, To: Galle)
      </p>
    </div>
  );
};

export default TrainListheader;
